import $ from 'jquery';
// import { getHeight, getScrollTop, onScroll } from '../utils/window';
import shopify from '../utils/shopify';
// import Client from 'shopify-buy';
// import Cookie from 'js-cookie';

export default function productsPage() {

    if(!window.shopifyClient) {
        window.shopifyClient = new shopify('39d75171165a991020d556553370456c', 'cuvee-chocolate.myshopify.com');
    }
    // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');

    window.shopifyClient.setupCheckoutInfo();
    window.shopifyClient.setupCartContainer('.cart-num');
    // window.shopifyClient.setupNote('test');

    if($('.product-page').length > 0) {
        const $qtySelect = $('#qty_select');
        const $addToCartButton = $('.add-to-cart .purchase_button');
        const $form = $('.add-to-cart > form');
        const $hiddenMainId = $('.add-to-cart [name="mainId"]');
        const $props = $('.add-to-cart [name="props"]');
        const props = JSON.parse($props.val());
        const $hiddenQuantity = $('.add-to-cart [name="quantity"]');

        // const $cartNum = $('.cart-num');
        // const $form = $('.add-to-cart form');

        // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');

        $qtySelect.on('change', function() {
            $hiddenQuantity.val(this.value);
        });

        $form.submit(function(e){
            e.preventDefault();

            let cusAttr = null;
            
            if (props.summary && props.summary.length) {
                cusAttr = [
                    {
                        key: "summary",
                        value: props.summary
                    },
                ];
            }

            const selectedVariant = getSelectedVariant()

            window.shopifyClient.addProductToCart([
                {
                    variantId: selectedVariant ? btoa('gid://shopify/ProductVariant/'+String(selectedVariant.id)) : $hiddenMainId.val(),
                    quantity: parseInt($hiddenQuantity.val(), 10),
                    customAttributes: cusAttr,
                }
            ]);

            return false;
        });

        $('.option select.option').change(function() {
            const variant = getSelectedVariant()

            if (variant) {
                $('.product-page-main .text h4').text('$' + variant.price)
            }
        })

        function getSelectedVariant() {
            const variants = JSON.parse($('#shopify_variants').html())

            const options = []

            $('.option select.option').each(function() {
                options[$(this).attr('name')] = $(this).val()
            })

            let selectedVariant

            for (const variant of variants) {
                let match = true
                for (const i in options) {
                    if (variant['option' + String(Number(i)+1)] !== options[i]) {
                        match = false
                        break
                    }
                }
                if (match) {
                    selectedVariant = variant
                    break
                }
            }

            return selectedVariant
        }

        // $addToCartButton.click(function(e){
            // e.preventDefault();

            // let cusAttr = [
            //     {
            //         key: "summary",
            //         value: props.summary
            //     },
                // {
                //     key: "inventory",
                //     value: props.inventory.toString()
                // },
                // {
                //     key: "weight",
                //     value: props.weight
                // },
                // {
                //     key: "imageUrl",
                //     value: props.image
                // },
            // ];

            // window.shopifyClient.addProductToCart([
            //     {
            //         variantId: $hiddenMainId.val(),
            //         quantity: parseInt($hiddenQuantity.val(), 10),
            //         customAttributes: cusAttr,
            //     }
            // ]);
        // });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/pages/products.js